import createRoute        from '@widesk-ui/tools/createRoute';
import OrderItemUnitModel from '@models/shop/OrderItemUnitModel';

export default createRoute.table('/order_item_units', 'shop', 'OrderItemUnitTable', OrderItemUnitModel.localize('plural'));
